import { useState } from 'react';
const useIframeOnload = () => {
    const [iframeLoading, setIframeLoading] = useState(true);
    const handleOnLoad = () => {
        setIframeLoading(false);
    };

    return {
        iframeLoading,
        handleOnLoad,
    };
};

export default useIframeOnload;
